import { ChangeDetectionStrategy, Component, HostBinding, inject, type OnInit } from '@angular/core';
import { faKey, faLeftToLine, faPowerOff, faRightToLine } from '@fortawesome/pro-regular-svg-icons';
import { WebSessionService } from '@reconcept-platform/shared/authentication';
import { type NavConfig, NavigationService } from '@reconcept-platform/shared/navigation/nav-content';

@Component({
  selector: 'rcp-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SideNavComponent implements OnInit {
  private session = inject(WebSessionService);
  navigationService = inject(NavigationService);

  isLoggedIn: boolean | undefined;

  @HostBinding('class.hide-tiny')
  get hideSideNavOnMobile() {
    return !this.isLoggedIn;
  }

  @HostBinding('class.sidebar-expanded')
  get isExpanded() {
    return !this.navigationService.sidebarIsCollapsed();
  }

  @HostBinding('class.hidden')
  get hasNoNav(): boolean {
    return !this.navConfig || !this.navConfig?.sideNavTemplate;
  }

  get navConfig(): NavConfig {
    return this.navigationService.getNavConfig();
  }

  ngOnInit() {
    this.session.isLoggedIn().subscribe((isLoggedIn) => (this.isLoggedIn = isLoggedIn));
  }

  clickMenu() {
    this.navigationService.toggleSidebar();
  }

  clickLogout($event: any) {
    $event.preventDefault();

    // try to lock, if not possible, log out
    // if(!this.viewerService.lockApp()){
    this.session.logout();
    // }
  }

  protected readonly falRightToLine = faRightToLine;
  protected readonly falLeftToLine = faLeftToLine;
  protected readonly faKey = faKey;
  protected readonly faPowerOff = faPowerOff;
}
